<figure>
  <img alt="Bobby Calf" src="assets/images/bobby-calf.jpg" />
</figure>
<section class="preseason-info">
  <h2 class="title">Bobby Calf request system</h2>
  <p class="content">Your property has not been assigned to a pick-up calendar yet. This will happen before we start picking up from your area.</p>
  <p class="footer">If this has not been done by the time you are ready to supply please contact <a href="mailto:livestockadmin@anzcofoods.com">livestockadmin@anzcofoods.com</a></p>
</section>
